import React, { useState, useEffect, useContext } from "react"
import { useDispatch, useSelector } from "react-redux";
import { Slider } from "@material-ui/core";
import CurrencyFormat from 'react-currency-format';
import SocketContext from "../../context/SocketContext";
import { useTranslation } from "react-i18next";

//import api
import { orderPlace, updateTradeAsset } from "../../api/tradeAction"

//import lib
import { encryptObject } from "../../lib/cryptoJS"
import { toFixedDown, truncateDecimals } from "../../lib/roundOf"
import { toastAlert } from "../../lib/toastAlert";
import isEmpty from '../../lib/isEmpty';

//import validation
import { OrderValidate } from "./validation"



function valuetext(value) {
    return `${value}%`;
}


const initialFormValue = {
    quantity: 0,
    price: 0,
    leverage: 0,
}

const Orderplace = (props) => {

    //props
    const { type, pairData } = props

    //state
    const [formValue, setFormValue] = useState(initialFormValue);
    const [loader, setLoader] = useState(false);

    const { quantity, price, leverage } = formValue;

    const socketContext = useContext(SocketContext);
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation()

    //redux
    const { firstCurrency, secondCurrency } = useSelector(
        (state) => state.tradeAsset
    );
    const priceConversion = useSelector((state) => state.priceConversion);
    const tradePair = useSelector((state) => state.tradePair);
    const marketPrice = useSelector((state) => state.marketPrice)

    //function
    const handleTotal = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        // if (name == "quantity") {
        //     if (/[^0-9.]/.test(value)) return;
        // }
        let formData = { ...formValue, ...{ [name]: toFixedDown(value, tradePair?.secondFloatDigit) } };
        setFormValue(formData);
        if (value) {
            setLoader(false)
        }
    };

    const handleMax = () => {
        let total = secondCurrency?.stakeBal - secondCurrency?.lockedBal
        let Markprice = type === "buy" ? marketPrice?.askPrice : marketPrice?.bidPrice;
        let price = total / Markprice * tradePair?.leverage
        let formData = { ...formValue, ...{ ["quantity"]: toFixedDown(price, tradePair?.secondFloatDigit) } };
        setFormValue(formData);
    }


    const handleClick = (value) => {
        try {
            let amount = quantity
            if (value === 'sub' && amount > 0) {
                amount--
            } else if (value === 'add') {
                amount++
            }
            let formData = { ...formValue, ...{ ["quantity"]: toFixedDown(amount, tradePair.secondFloatDigit) } };
            setFormValue(formData);
        } catch (err) {
            console.log(err, 'errror')
        }
    }


    const handleSubmit = async () => {
        try {
            let reqData = {
                price: price,
                quantity: quantity,
                buyorsell: type,
                pairId: tradePair.pairId,
                newdate: new Date(),
                action: "open",

            };
            const validateError = await OrderValidate(reqData);
            if (!isEmpty(validateError)) {
                setLoader(false);
                toastAlert("error", t(validateError[Object.keys(validateError)[0]]), "limitOrder");
                return;
            }

            let encryptToken = {
                token: encryptObject(reqData),
            };
            setLoader(true);
            let { status, message, error, il8 } = await orderPlace(
                encryptToken
            )
            setTimeout(() => {
                setLoader(false);
            }, 500)
            if (status == "success") {
                toastAlert("success", t(message, il8), "spotOrder");
            } else {
                setLoader(false);
                if (!isEmpty(error)) {
                    toastAlert("error", error[Object.keys(error)[0]], "limitOrder");
                    return;
                }
                toastAlert("error", t(message, il8), "spotOrder");
            }
        } catch (err) {
            setLoader(false);
            console.log(err, 'errror')
        }
    };




    useEffect(() => {
        setFormValue({ ...formValue, ...{ ["leverage"]: pairData?.leverage } })
    }, [type, pairData, quantity, priceConversion, marketPrice])



    useEffect(() => {
        // socket
        socketContext.socket.on("updateTradeAsset", (result) => {
            updateTradeAsset(dispatch, result);
        });
    }, []);

    // console.log(loader, 'marketPricemarketPrice')
    let Balance = secondCurrency.stakeBal - secondCurrency.lockedBal
    let margin = marketPrice?.markPrice * (quantity / 100)
    return (
        <>

            <div class="form-group">
                <div className="d-flex justify-content-between gap-10 flex-wrap">
                    <label for="amount" class="form-label">
                        {t("QUANTITY")}
                    </label>
                    <label class="form-label">{t('AVAILABLE_BALANCE')}: <CurrencyFormat displayType={'text'} thousandSeparator={true} value={truncateDecimals(Balance, tradePair.secondFloatDigit)} /> {pairData.secondCurrencySymbol}</label>
                </div>
                <div className="mt-1 w-full self-stretch h-[47px] p-3 rounded-sm outline outline-1 outline-offset-[-1px] outline-gray-500/25 inline-flex justify-start items-center gap-3">
                    <div className=" relative bg-neutral-700 overflow-hidden cursor-pointer" onClick={() => handleClick("sub")}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="20" height="20" fill="#395645" />
                            <path d="M15.8343 10H4.16602" stroke="white" stroke-width="1.5" stroke-linecap="square" />
                        </svg>                    </div>
                    <div className="flex-1 flex justify-start items-center gap-2.5">
                        <input
                            type="number"
                            className="cus_input w-full !bg-transparent !border-none outline-none justify-center text-neutral-700 text-sm font-semibold font-['Roobert']"
                            name="quantity"
                            value={quantity}
                            onChange={handleTotal}
                            placeholder={t("QUANTITY_PLACEHOLDER")}
                        />
                    </div>
                    <div className=" relative bg-neutral-700 overflow-hidden cursor-pointer" onClick={() => handleClick("add")}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="20" height="20" fill="#395645" />
                            <path d="M10 4.16602V15.8343" stroke="white" stroke-width="1.5" stroke-linecap="square" />
                            <path d="M15.8344 10.002H4.16602" stroke="white" stroke-width="1.5" stroke-linecap="square" />
                        </svg>
                    </div>
                </div>
                <div className="d-flex justify-content-between gap-10 flex-wrap">
                    <label for="amount" class="form-label">
                    </label>
                    <label className="max_label"
                        onClick={handleMax}
                    >{t("MAX")}</label>
                </div>
            </div>

            <div className="form-group">
                <div className="rcslider_custom">
                    <label>{t("LEVERAGE")}</label>: <span>{leverage}x</span>
                    <Slider
                        getAriaValueText={valuetext}
                        aria-labelledby="discrete-slider-custom"
                        step={1}
                        valueLabelDisplay="auto"
                        value={leverage}
                        color={"#00b881"}
                    />
                </div>
            </div>
            <div className="form-group">
                <div className="d-flex justify-content-between">
                    <label>{t("TRADE_SIZE")}:</label> <span>{quantity}</span>{" "}
                </div>
                <div className="d-flex justify-content-between">
                    <label>{t("PIP_VALUE")}:</label> <span>{toFixedDown(quantity / 100, 2)}</span>{" "}
                </div>
                <div className="d-flex justify-content-between">
                    <label>{t("USED_MARGIN")}:</label> <span> <CurrencyFormat displayType={'text'} thousandSeparator={true} value={truncateDecimals(margin, 2)} /></span>
                </div>
            </div>
            <div>
                {loader ?
                    <button class={type === 'buy' ? "primary_btn w-100" : "primary_btn w-100 primary_sell_btn"} disabled={true} >{t("LOADING")} ...</button> :
                    <button onClick={handleSubmit} class={type === 'buy' ? "primary_btn w-100" : "primary_btn w-100 primary_sell_btn"}>{type === 'buy' ? t("BUY") : t("SELL")}</button>
                }
            </div>
        </>
    )
}


export default Orderplace;